module.exports = __webpack_public_path__ + "static/DHCM1-4060453ef779e4f3535cd0620e02b494.png";